import { render, staticRenderFns } from "./viewrecord.vue?vue&type=template&id=070e8f36&scoped=true&"
import script from "./viewrecord.vue?vue&type=script&lang=js&"
export * from "./viewrecord.vue?vue&type=script&lang=js&"
import style0 from "./viewrecord.vue?vue&type=style&index=0&id=070e8f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e8f36",
  null
  
)

export default component.exports